import { FormContainer } from '@/components/FormContainer';
import { NotFoundScene } from '@/scenes/NotFound';

export const NotFoundPage = () => {
  return (
    <>
      <FormContainer>
        <NotFoundScene />
      </FormContainer>
    </>
  );
};
